import React from 'react';
import './information.scss';
import { useAtomValue } from 'jotai';
import { SingleSeriesAtom } from '../../../../store/SeriesStore';


export function Information(): JSX.Element {
    const series = useAtomValue(SingleSeriesAtom);
    console.log('series?.genres', series);


    return <div className='information-wrapper'>
        <div className='warnings-container'>
            <div className='title-container'>
                <div className='title-wrapper title-tag-wrapper'>
                    <h4 className='title'>Tags</h4>

                    {/*<div className='status-wrapper'>*/}
                    {/*    <span className='title'>Status</span>*/}
                    {/*    <span className='status-text'>{series?.completionStatus}</span>*/}
                    {/*</div>*/}

                </div>
            </div>


            <div className='content-warnings-wrapper'>
                <div className='content-warnings-item content-warnings-age'>{series?.ageRating?.toUpperCase()}</div>
                {series?.genres?.length > 0 && series?.genres.map((genre, index) => {
                    return <div key={index} className='content-warnings-item'>{genre.name}</div>;
                })}
            </div>
        </div>


        <div className='warnings-container'>
            <div className='title-container'>
                <div className='title-wrapper'>
                    <h4 className='title'>Credits</h4>
                </div>
            </div>


            <div className='content-warnings-wrapper'>
                {series?.creators?.map((creator) => {
                    return <div key={creator.name} className='credit-item'>
                        <span className={'credits-title'}>{creator.name}</span>
                        <span className={'credits-text'}>{creator.title}</span>
                    </div>;
                })}
            </div>
        </div>

        <div className='warnings-container'>
            <div className='title-container'>
                <div className='title-wrapper'>
                    <h4 className='title'>Publishing Info</h4>
                </div>
            </div>


            <div className='publishing-wrapper'>
                <img src={series?.publisherBrandURL} alt={'Publisher Brand Image'} className='publishing-image'/>
                <span className={'publishing-name'}>{series?.publisher}</span>
            </div>
        </div>

    </div>;
}